<template>
<div class="quesEditDialog ">
    <el-dialog @close="_cancel" :title="'添加子试题'" :visible.sync="dialogVisible" width="940px">
        <div class="tab-container">
            <template v-for="item in tablist" >
                <el-button type="primary" :plain="form.questiontype !== item.code" @click="clickTab(item.code)" v-if="item.code!=7" :disabled="type==2">{{item.name}}</el-button>
            </template>
        </div>
        <div class="container">
            <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="默认分数" required v-if="form.questiontype != '7'">
                    <el-input v-model="form.defaultscore" placeholder="请输入试题默认分数（可保留两位小数）"></el-input>
                </el-form-item>
                <!-- 根据类别显示不同的页面 -->
                <Radio v-if="form.questiontype == '1'" :formData='form' @childSubmitFormApi='childSubmitFormApi' :type="type" @cancel="_cancel"></Radio>
                <!-- end 单选 -->
                <Checkbox v-if="form.questiontype == '2' || form.questiontype == '3'" :formData='form' @childSubmitFormApi='childSubmitFormApi' @cancel="_cancel" :type="type"></Checkbox>
                <!-- end 多选 || 不定项选择题-->
                <!-- <Checkbox v-if="form.questiontype == '3'" :form='form'></Checkbox> -->
                <!-- end 不定项选择题 -->
                <Judge v-show="form.questiontype == '4'" :formData='form' @childSubmitFormApi='childSubmitFormApi' @cancel="_cancel" :type="type"></Judge>
                <!-- end 判断题 -->
                <Fill v-if="form.questiontype == '5'" :formData='form' @childSubmitFormApi='childSubmitFormApi' @cancel="_cancel" :type="type"></Fill>
                <!-- end 填空题 -->
                <QuestionsAndAnswers v-if="form.questiontype == '6'" :formData='form' @childSubmitFormApi='childSubmitFormApi' @cancel="_cancel" :type="type"></QuestionsAndAnswers>
                <!-- end 问答题 -->
            </el-form>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {saveHostRoleInfo} from 'api/brandBusiness'
import {saveOrUpdateQuestionInfo} from 'api/questionApi'
import {mapGetters, mapActions} from 'vuex'
import Radio from 'views/questionbank/components/Radio'
import Checkbox from 'views/questionbank/components/Checkbox'
import Judge from 'views/questionbank/components/Judge'
import Fill from 'views/questionbank/components/Fill'
import QuestionsAndAnswers from 'views/questionbank/components/QuestionsAndAnswers'
import {question} from 'api/enumCode'
export default {
    name: 'quesEditDialog',
    props: ['dataList'],
    data() {
        return {
            dialogVisible: false,
            tablist: question.type,
            form: {  //表单
                innerid: '', // 试题id，新增为空
                questiontype: '', // 试题类型  1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题 默认进来单选
                cateid: '0', // 试题分类Code
                defaultscore: '', // 试题默认分数
                subject: '', // 试题题干Html
                quesanalysis: '', // 试题解析
                isquesorder: '0', // 答案匹配顺序-填空有效 0否 1是
                isscorebyblank: '0', // 是否按空得分-填空有效 0否 1是
                referenceanswer: '', // 参考答案-问答有效
                optioninfo: [], // 试题选项信息，选择题有效，解析之后为一个数组，前端选先后顺序组装 optioncontent 选项名称 isrightanswer 是否正确答案 0否 1是
                finalanswer: '', // 填空、判断有效 1、对于判断题，答案记录为T或者F，用户提交也提交T或者F，直接对比 2、对于填空题，各个空之间以|分隔，每空有多答案以分号分隔，如果答案中含有|和分号，都替换成逗号，前端组装后提交
            },
            type: 1, // 1新增 2编辑
            selectedIndex: ''
        }
    },
    mounted() {
    },
    methods: {
        openDialog(type, selectedIndex) {
            this.type = type
            if (this.type == 2) {
                this.selectedIndex = selectedIndex
                this.form = this.dataList[this.selectedIndex]
            } else {
                this._initForm()
                this.form.questiontype = '1'
            }
            this.dialogVisible = true
        },
        _cancel() {
            this._initForm()
            this.dialogVisible = false
        },
        _initForm() { // 初始化列表数据
            this.form = {  //表单
                innerid: '', // 试题id，新增为空
                questiontype: '', // 试题类型  1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题
                cateid: '0', // 试题分类Code
                // defaultscore: '', // 试题默认分数
                subject: '', // 试题题干Html
                quesanalysis: '', // 试题解析
                isquesorder: '0', // 答案匹配顺序-填空有效 0否 1是
                isscorebyblank: '0', // 是否按空得分-填空有效 0否 1是
                referenceanswer: '', // 参考答案-问答有效
                optioninfo: [], // 试题选项信息，选择题有效，解析之后为一个数组，前端选先后顺序组装 optioncontent 选项名称 isrightanswer 是否正确答案 0否 1是
                finalanswer: '', // 填空、判断有效 1、对于判断题，答案记录为T或者F，用户提交也提交T或者F，直接对比 2、对于填空题，各个空之间以|分隔，每空有多答案以分号分隔，如果答案中含有|和分号，都替换成逗号，前端组装后提交
            }
        },
        clickTab(type) {  // 列表切换
            this._initForm()
            this.form.questiontype = type
        },
        childSubmitFormApi(obj) {    // 子组件提交api方法
            obj = JSON.parse(obj)
            obj.optioninfo = JSON.stringify(obj.optioninfo)
            if (obj.subject.length == 0) {
                this.$message.error('题目不能为空')
                return
            } else if (/^\d+(\.\d{1,2})?$/.test(obj.defaultscore) == false) {
                this.$message.error('请输入分数且仅可保留两位小数')
                return
            } else {
                if (this.type == 1) {
                    this.$emit('addQuesChild', obj)
                } else {
                    this.$emit('updateQuesChild', obj, this.selectedIndex)
                }
                this._cancel()
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Radio,
        Checkbox,
        Judge,
        Fill,
        QuestionsAndAnswers
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";

.quesEditDialog {
    textarea[name = "editorValue"] {
        display: none
    }
    .el-form-item {
        .el-form-item__label {
            text-align: right !important;
        }
        &.is-required {
            .el-form-item__label::after{
                content: "*";
                color: #F56C6C;
                margin-left: 4px;
            }
            .el-form-item__label::before {
                display: none;
            }
        }
    }
    .type {
        margin-right: 20px;
    }
    .tab-container {
        padding: 10px 40px 0 20px;
        .el-button {
            margin-right: 20px;
        }
    }
    .container {
        width: 800px;
    }
    .uEditor .edui-default .edui-editor, .uEditor .edui-default .edui-editor-iframeholder{
        width: 750px !important;
        height: 150px;
    }
}
</style>
